<p-confirmDialog></p-confirmDialog>

<p-toast [life]="10000" />

<div id="fundcodeCheckbooks" data-cy="fundcodeCheckbooks">
    <h1>Accounting System Settings</h1>

    <p-card styleClass="mb-3">
        <div class="flex justify-content-start align-items-center gap-3">
            <b>Accounting System</b> 
            <p-dropdown id="accountingSystem" placeholder="Please Select" />
            <rc-generic-button 
                label="Save"
                size="small"
                data-cy="save-accounting-system"
                />
        </div>
    </p-card>

    <p-card>
        <!-- [classes]="['absolute mt-3']" -->
        <rc-generic-button 
            level="secondary"
            borderStyle="solid"
            [classes]="['mt-2 mb-4']"
            label="Add Fund Code Checkbook"
            (clickHandler)="onAddEditFundCodeCheckbooks()"
            data-cy="add-new-fundcode-checkbook-button"
            />
        <rc-generic-table 
            exportLabel="Campaign Settings Accounting Systems"
            [columns]="columns"
            [rows]="data"
            data-cy="fundcode-checkbooks-table"
            [formattedText]="formattedText"
            (actionClicked)="onActionClicked($event)" />
    </p-card>
</div>

<!-- Edit Fund Code Checkbook MODAL -->
<p-dialog [(visible)]="showAddEditDialog"
    [modal]="true"
    header="{{ isEditMode ? 'Edit Fund Code Checkbook' : 'Add Fund Code Checkbook' }}"
    styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

    <ng-container>
        <form [formGroup]="addEditFundCode">
            <div class="formgrid grid">
                <div class="field col-12" *ngIf="isEntityCampaign">
                    <label for="childCampaignId" class="field-label required">Campaign</label>
                    <p-dropdown id="childCampaignId" formControlName="childCampaignId"
                                [options]="childCampaigns" optionLabel="name"
                                placeholder="Select Campaign" optionValue="childCampaignId" />
                    <div *ngIf="addEditFundCode.get('childCampaignId')?.invalid && addEditFundCode.get('childCampaignId')?.touched"
                    class="block p-error">
                    <small id="child-campaign-error" class="error">
                        Please select a Campaign.
                    </small>
                    </div>
                </div>
                <div class="field col-12">
                    <label for="fundCode" class="field-label required">Fund Code</label>
                    <p-dropdown id="fundCodeId" formControlName="fundCodeId"
                                [options]="fundcodes" optionLabel="value"
                                placeholder="Please Select" optionValue="key" />    
                    <div *ngIf="addEditFundCode.get('fundCodeId')?.invalid && addEditFundCode.get('fundCodeId')?.touched"
                    class="block p-error">
                        <small id="fund-code-error" class="error">
                            Please enter a Fund Code.
                        </small>
                    </div>
                </div>
                <div class="field col-12">
                    <label for="checkbooks" class="field-label required">Checkbooks</label>
                    <p-multiSelect [options]="checkbooks"                  
                        formControlName="selectedCheckbooks"
                        [maxSelectedLabels]="2"                   
                        optionLabel="value"
                        optionValue="key"
                        [selectedItemsLabel]="'{0} items selected'"
                        display="chip"
                        placeholder="Choose Checkbooks"
                        id="checkbooks">
                    </p-multiSelect>
                    <small *ngIf="isEditMode" class="font-italic inline-block mt-3">
                        Please note: checkbooks with assigned expenses can't be removed.
                    </small>
                </div>
            </div>
        </form>
    </ng-container>   

    <ng-template pTemplate="footer">
        <rc-generic-button label="Cancel" borderStyle="text-only" (click)="onCloseAddEditDialog()" />
        <rc-generic-button label="Save" (click)="onSaveFundcodeCheckbooks()" />
    </ng-template>
</p-dialog>